'use client';

import {createContext, useContext, type ReactNode} from 'react';
import type {SiteConfig} from './types';

const SiteConfigContext = createContext<SiteConfig | null>(null);

interface SiteConfigProviderProps {
  config: SiteConfig;
  children: ReactNode;
}

export function SiteConfigProvider({config, children}: SiteConfigProviderProps) {
  return <SiteConfigContext.Provider value={config}>{children}</SiteConfigContext.Provider>;
}

export function useSiteConfig(): SiteConfig {
  const config = useContext(SiteConfigContext);
  if (!config) {
    throw new Error('useSiteConfig must be used within <SiteConfigProvider>');
  }
  return config;
}
